const USERPOOL_ID = import.meta.env.VITE_USERPOOL_ID;
const COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN;
const USERPOOL_CLIENT_ID = import.meta.env.VITE_USERPOOL_CLIENT_ID;

export function createSilentAuthUrl() {
  const url = new URL(`https://${COGNITO_DOMAIN}/oauth2/authorize`);

  url.searchParams.set("response_type", "code");
  url.searchParams.set("client_id", USERPOOL_CLIENT_ID);
  url.searchParams.set(
    "redirect_uri",
    window.location.origin + "/auth/silent-callback",
  );
  url.searchParams.set("scope", "openid profile email");
  url.searchParams.set("state", "probe");
  url.searchParams.set("prompt", "none");

  return url.toString();
}

const needsSilentAuth = () => {
  if (!COGNITO_DOMAIN || !USERPOOL_ID || !USERPOOL_CLIENT_ID) {
    return false;
  }

  const url = new URL(`https://${COGNITO_DOMAIN}/`);
  if (
    url.host.split(".").slice(-2).join(".") !==
    window.location.host.split(".").slice(-2).join(".")
  ) {
    return false;
  }

  const EXCLUDED_PATHS = [
    "/auth/silent-callback",
    "/conferma-registrazione",
    "/password-dimenticata",
    "/cambia-password",
    "/registrazione",
  ];
  if (EXCLUDED_PATHS.includes(window.location.pathname)) {
    return false;
  }

  return true;
};

export const silentAuth = async () => {
  if (needsSilentAuth()) {
    const iframe = document.createElement("iframe");
    iframe.id = "silent-auth-iframe";
    iframe.style.display = "none";
    iframe.src = createSilentAuthUrl();
    const existingIframe = document.querySelector("#silent-auth-iframe");
    if (existingIframe) {
      existingIframe.remove();
    }
    document.body.appendChild(iframe);
  }
};

export const silentCallback = async () => {
  if (window.parent === window) {
    window.location.href = window.location.origin;
    return;
  }
  const params = new URLSearchParams(window.location.search);
  const error = params.get("error");

  if (error) {
    window.parent.postMessage(
      {
        type: "COGNITO_SILENT_AUTH",
        status: "anonymous",
        error,
      },
      window.location.origin,
    );

    return;
  }

  const code = params.get("code");
  const state = params.get("state");

  if (!code || !state) {
    return;
  }

  if (state === "probe") {
    window.history.replaceState({}, document.title, window.location.pathname);

    const Amplify = (await import("aws-amplify")).Amplify;
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: USERPOOL_ID,
          userPoolClientId: USERPOOL_CLIENT_ID,
          loginWith: COGNITO_DOMAIN
            ? {
                oauth: {
                  domain: COGNITO_DOMAIN,
                  redirectSignIn: [
                    window.location.origin + "/auth/silent-callback",
                  ],
                  redirectSignOut: [window.location.origin + "/area-clienti"],
                  responseType: "code",
                  scopes: [
                    "openid",
                    "aws.cognito.signin.user.admin",
                    "email",
                    "profile",
                  ],
                },
              }
            : undefined,
        },
      },
    });

    const { signInWithRedirect } = await import("aws-amplify/auth");
    signInWithRedirect({
      options: {
        lang: "it",
      },
    });
  } else {
    const { Hub } = await import("aws-amplify/utils");
    Hub.listen("auth", (data) => {
      const { payload } = data;
      console.log("Auth event:", payload.event);
      if (payload.event === "signInWithRedirect") {
        window.parent.postMessage(
          {
            type: "COGNITO_SILENT_AUTH",
            status: "authenticated",
          },
          window.location.origin,
        );
      }
    });
    console.log(
      "Set up auth listener, waiting for signInWithRedirect event...",
    );
    const Amplify = (await import("aws-amplify")).Amplify;
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: USERPOOL_ID,
          userPoolClientId: USERPOOL_CLIENT_ID,
          loginWith: COGNITO_DOMAIN
            ? {
                oauth: {
                  domain: COGNITO_DOMAIN,
                  redirectSignIn: [
                    window.location.origin + "/auth/silent-callback",
                  ],
                  redirectSignOut: [window.location.origin + "/area-clienti"],
                  responseType: "code",
                  scopes: [
                    "openid",
                    "aws.cognito.signin.user.admin",
                    "email",
                    "profile",
                  ],
                },
              }
            : undefined,
        },
      },
    });
    console.log("Silent auth success, waiting for auth event...");
  }
};
